import { render, staticRenderFns } from "./NavLinks.vue?vue&type=template&id=7023a7a0&"
import script from "./NavLinks.vue?vue&type=script&lang=js&"
export * from "./NavLinks.vue?vue&type=script&lang=js&"
import style0 from "./NavLinks.vue?vue&type=style&index=0&id=7023a7a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports